// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"195":"1f2462c2","204":"1f2462c2","977":"1f2462c2"}[chunkId] + ".chunk.css";
};